<script lang="ts">
	import Button from '$lib/components/Button/Button.svelte';
	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';

	const { t } = getTranslate();

	export let href: string;
	export let title: string;
	export let additionalClass = '';
</script>

<div
	class={classes(
		'absolute h-full w-full flex flex-col space-y-8 justify-center items-center bg-black bg-svg bg-overlay-video',
		additionalClass
	)}
>
	<h2 class="text-lg md:text-2xl text-center max-w-[75%] pt-28 md:pt-0">
		{title}
	</h2>
	<a {href}>
		<Button additionalClass="min-w-max" on:click on:keypress
			>{$t('trailer-overlay.button.text')}</Button
		>
	</a>
</div>
